import { Types } from '@scorenco/core';

import { PageSeo } from '@/components';
import { RouteKey } from '@/routes';

type CompetitionMetadataProps = {
  competition?: Types.Competitions_Competition_Detail;
};

const TITLE = "#competition# - #sport# - Suivez tous les matchs sur Score'n'co";
const DESCRIPTION =
  'Retrouvez les calendriers, classements et résultats des matchs de la competition de #sport# "#competition#".';

export const CompetitionMetadata = ({
  competition,
}: CompetitionMetadataProps) => {
  if (!competition) {
    return null;
  }
  const competitionName = competition?.name || '';
  const sportName = competition?.sport?.name || '';

  return (
    <PageSeo
      title={TITLE.replace('#competition#', competitionName).replace(
        '#sport#',
        sportName
      )}
      description={DESCRIPTION.replace(
        '#competition#',
        competitionName
      ).replace('#sport#', sportName)}
      url={{
        routeKey: RouteKey.Competition,
        params: {
          sport: competition.sport?.slug || '',
          competition:
            competition.slug + '-' + competition.id?.toString(36) || '',
        },
      }}
    />
  );
};
